import Vue from 'vue'
import Vuex from 'vuex'
import { secondsToFullTimestamp, secondsToFormatDateInput} from '@/Helper.js' 
import { numeracion_de_documentos,  coleccion_entradas, coleccion_entradas_a_procesar,  db, customAuth } from '../../FirebaseConfig';
Vue.use(Vuex)
export default {
    namespaced:true,
        state: {
            data:{
              items: [],
              warehouse: '',
            },
            massiveDialog: false,
            loading: true,
            registro:[],
            cantidad_de_registros: 0,
            selectedKey:'',
            registerDialog: false,
            annulDialog: false,
            paso_de_formulario: 1,
        },

        actions: {
          obtener_todo:({state}, event)=>{
            state.loading = true
            const {itemsPerPage, page} = event
            let ref = coleccion_entradas

            if(state.cantidad_de_registros > 0 ) ref = ref.where('numero_de_operacion', '<=', state.cantidad_de_registros - itemsPerPage * (page-1) )
            
            ref.limit(itemsPerPage).orderBy('numero_de_operacion', 'desc').onSnapshot(collection=>{
              const colección = []
              collection.docs.map( item => colección.push({ ...item.data(), id: item.id }) )
              state.registro = colección
              state.loading = false
            })
            numeracion_de_documentos.collection('Nota de entrada').doc('00').onSnapshot( doc=> state.cantidad_de_registros = doc.exists ? doc.data().numeracion : 0 )
          },
          lookingForDates:({state})=>{
              state.record = []
              coleccion_entradas
              .where('creado_el', '>', new Date(state.searchingDate[0]))
              .where('creado_el', '<', new Date(state.searchingDate[1]))
              .onSnapshot(collection=>{
                const colección = []
                collection.docs.map( item => colección.push({ ...item.data(), id: item.id }) )
                state.registro = colección
                state.loading = false
              })
              numeracion_de_documentos.collection('Nota de entrada').doc('00').onSnapshot(doc=>state.cantidad_de_registros = doc.exists ? doc.data().numeracion : 0)
          },
          add: async (context, )=>{
              let { dispatch } = context
              context.state.loading = true
              if(context.state.selectedKey=='') {

                  let numeracion = await numeracion_de_documentos.collection('Nota de entrada').doc('00').get()
                  let nueva_numeracion = (!numeracion.exists) ? 1 : numeracion.data().numeracion + 1

                  let datos_a_grabar = {
                      ...context.state.data,
                      creado_el: new Date, 
                      creado_por: customAuth.currentUser.displayName,
                      documento_de_operacion: 'Nota de entrada',
                      numero_de_operacion: nueva_numeracion,
                      igv: Number(context.state.data.items.map(item => (item.incluye_igv) ? Number(item.valor_unitario) / 1.18 * 0.18 : 0).reduce((a, b) =>  a + b ).toFixed(2)), 
                      items: context.state.data.items.map(item => ({
                          ...item, 
                          valor_unitario: item.incluye_igv ?  Number(Number(Number(item.valor_unitario)/1.18).toFixed(2)) : Number(item.valor_unitario), cantidad: Number(item.cantidad) ,
                          cantidad: Number(item.cantidad),
                      }) ),
                      valor_de_venta: Number(context.state.data.items.map(item => Number(item.cantidad) * Number(item.valor_unitario) ).reduce((a, b) =>  a + b ).toFixed(2)) ,
                      total: Number(context.state.data.items.map(item => (item.incluye_igv) ? Number(item.cantidad) * Number(item.valor_unitario) * 1.18 : Number(item.cantidad) * Number(item.valor_unitario)).reduce((a, b) =>  a + b ).toFixed(2)),
                      warehouse: await context.dispatch('Warehouse/getMainWarehouse', '', {root: true}),
                      estado_del_documento: 'esperando',

                  }
                  datos_a_grabar.items.map(item => delete item.existence)
                  coleccion_entradas.add(datos_a_grabar).then(() => {
                      context.state.loading = false
                      numeracion_de_documentos.collection('Nota de entrada').doc('00').set({numeracion: nueva_numeracion})
                      context.commit('Helpers/launchSnackbar', 'Se ha registrado la nota de entrada', { root: true })
                      context.state.registerDialog = false
                  }).catch( error => {
                      context.state.loading = false
                      context.commit('Helpers/launchSnackbar', error, { root: true })
                      context.state.registerDialog = false
                  })

                  let { total_gravada, serie_comprobante, numero_comprobante, tipo_de_comprobante, proveedor_denominacion, condiciones_de_pago, motivo_de_traslado } = datos_a_grabar
                  if(motivo_de_traslado == '02') dispatch('Movimientos_contables/movimiento_contable', {valor: total_gravada, regla:"Compra", proveedor_denominacion, fecha_caducidad: condiciones_de_pago, referencia: `${serie_comprobante}${numero_comprobante}${tipo_de_comprobante} `, fecha: new Date}, { root: true }) 
                  
              } else {
                  coleccion_entradas.doc(context.state.data.key).update({
                      ...context.state.data, 
                      actualizado_el: new Date(), 
                      fecha: new Date(context.state.data.date),
                      igv: Number(context.state.data.items.map(item => (item.incluye_igv) ? Number(item.valor_unitario)/1.18*0.18 : 0).reduce((a, b) =>  a + b ).toFixed(2)), 
                      valor_de_venta: Number(context.state.data.items.map(item => Number(item.cantidad) * (item.incluye_igv) ? Number(item.valor_unitario)/1.18 : Number(item.valor_unitario)).reduce((a, b) =>  a + b ).toFixed(2)) ,
                      total: Number(context.state.data.items.map(item => Number(item.cantidad) * (item.incluye_igv) ? Number(item.valor_unitario) : Number(item.valor_unitario)).reduce((a, b) =>  a + b ).toFixed(2)),
                  })
                  context.state.loading = false
                  context.state.registerDialog = false
                  context.dispatch('clearForm')
                  context.commit('Helpers/launchSnackbar', 'Se ha actualizado la operación', { root: true })
              }
          },
          annul:(context,key)=>{
              coleccion_entradas.doc(key).update({isAnnulled: true, annulledAt: new Date}).then(()=>{
                  context.commit('Helpers/launchSnackbar', 'Se ha anulado el documento', { root: true })
                  context.state.annulDialog = false
                  context.state.registerDialog = false
              })
          },
          get:(context, key)=>{
              coleccion_entradas.doc(key).get().then(doc=>{
                  context.state.data = {
                      ...doc.data(), 
                      key: key, 
                      fecha: secondsToFormatDateInput(doc.data().fecha),
                      creado_el: secondsToFullTimestamp(doc.data().creado_el),
                      annulledAt: secondsToFullTimestamp(doc.data().annulledAt),
                  }
                  context.state.selectedKey = key
                  context.state.registerDialog = true
                  context.state.paso_de_formulario = 3
              })
          },
          closeDocument:(context, key)=>coleccion_entradas.doc(key).update({isClose: true}),

          massiveAdd: async (context, data) => {
            let items_faltantes = []

            let obtener_productos_por_codigo = data.map(async item=>{
              let element = await context.dispatch('Product/getKeyByCode', item.code,  { root: true })
              if( !element ) items_faltantes.push(item.code)
              
              return {...element,  cantidad: Number(item.cantidad), valor_unitario: 0, descuento: 0, tipo_de_igv: 1 }
            })
            context.state.data.items = await Promise.all(obtener_productos_por_codigo)
            if ( items_faltantes.length > 0 ) return context.commit('Helpers/launchSnackbar', `Hay productos no identificados ${items_faltantes}`, { root: true })
            
            context.state.registerDialog = true
          },
          clearForm: context => {
              context.state.data= {
                  items: [],
                  fecha_de_emision: new Date().toISOString().substr(0, 10),                   
                  warehouse: [],
              }
              context.state.selectedKey = ''
          },
          abrir_documentos: async ({state, commit}) => {

            const registro = await coleccion_entradas.get()
            registro.docs.map( item => coleccion_entradas.doc(item.id).update( { estado_del_documento: 'esperando' } )
                .then(()=>commit('Helpers/launchSnackbar', 'Se ha abierto todos los documentos', { root: true }) ) 
                .catch(error=>commit('Helpers/launchSnackbar', error, { root: true }) ) 
            )

          },
          des_procesar: (context, key) => {
              coleccion_entradas.doc(key).update({estado_del_documento: 'esperando'})
          },
        },
        getters: {
          registro: state => state.registro.map(item =>{
            let comprobante_serie_numero = (item.numero_comprobante && item.serie_comprobante && item.nombre_de_comprobante) ?  `${item.nombre_de_comprobante}/${String(item.serie_comprobante).padStart(4, 0)}-${String(item.numero_comprobante).padStart(5, 0)}` : ''
            return ({...item, key: item,  fecha: secondsToFormatDateInput(item.fecha), comprobante_serie_numero })
          } 
        )
    }
}



